<app-orientation-warning />

<app-spinner [isVisible]="loadingService.isLoading()" />

<app-banner [isVisible]="metadata()?.showInfoBanner ?? false" />

<app-header />

<main>
  <router-outlet />
</main>

<app-footer />

<app-toast />
